import Vue from 'vue'
import App from './App.vue'

import vueTabz from 'vue-tabz';

Vue.config.productionTip = false

Vue.use(vueTabz);

new Vue({
  render: h => h(App),
}).$mount('#app')
